"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-header kiwi-theme-bg",
    on: {
      "click": _vm.onHeaderClick
    }
  }, [_vm.isChannel() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(_vm._s(_vm.buffer.name) + " ")])]), _c('div', {
    staticClass: "kiwi-header-center"
  }, [_vm.shouldShowTopic ? _c('div', {
    staticClass: "kiwi-header-topic",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedTopic)
    }
  }) : _vm._e()]), _vm.isJoined && _vm.isConnected ? _c('div', {
    key: _vm.buffer.id,
    staticClass: "kiwi-header-options"
  }, [_c('div', {
    staticClass: "kiwi-header-option kiwi-chatsi-toolbar-menu"
  }, [_c('a', {
    attrs: {
      "title": "Menú"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.chatsiOpenMenuDialog.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-nicklist",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'nicklist' || _vm.sidebarSection === 'user'
    }
  }, [_c('a', {
    attrs: {
      "title": _vm.$t('person', {
        count: Object.keys(_vm.buffer.users).length
      })
    },
    on: {
      "click": function ($event) {
        return _vm.sidebarState.toggleNicklist();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(Object.keys(_vm.buffer.users).length))])])]), _vm._l(_vm.pluginUiChannelElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "kiwi-header-option",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer,
          containerheader: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  })], 2) : _vm._e()] : _vm.isServer() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_vm._v(_vm._s(_vm.buffer.getNetwork().name))]), _vm._v(" " + _vm._s(_vm.buffer.getNetwork().name) + " ")])]), _c('div', {
    staticClass: "kiwi-header-center"
  }), _c('div', {
    staticClass: "kiwi-header-server-connection"
  }, [_vm.buffer.getNetwork().state === 'disconnected' ? _c('a', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": _vm.onConnectButtonClick
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('connect')) + " ")]) : _vm.buffer.getNetwork().state === 'connecting' ? _c('span', [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('connecting')) + " ")]) : _vm._e()])] : _vm.isQuery() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_c('away-status-indicator', {
    staticClass: "kiwi-header-awaystatus",
    attrs: {
      "network": _vm.buffer.getNetwork(),
      "user": _vm.network.userByName(_vm.buffer.name)
    }
  }), _vm._v(_vm._s(_vm.buffer.name) + " ")], 1), _c('away-status-indicator', {
    staticClass: "kiwi-header-awaystatus",
    attrs: {
      "network": _vm.buffer.getNetwork(),
      "user": _vm.network.userByName(_vm.buffer.name)
    }
  }), _vm._v(_vm._s(_vm.buffer.name) + " ")], 1)]), _c('div', {
    staticClass: "kiwi-header-center"
  }), _c('div', {
    key: _vm.buffer.id,
    staticClass: "kiwi-header-options"
  }, [_vm.userOnline ? _c('div', {
    staticClass: "kiwi-header-option kiwi-header-option-user",
    class: {
      'kiwi-header-option--active': _vm.sidebarSection === 'user'
    }
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.toggleUser();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._l(_vm.pluginUiQueryElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      staticClass: "kiwi-header-option",
      attrs: {
        "plugin-props": {
          buffer: _vm.buffer,
          containerheader: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  })], 2)] : _vm.isSpecial() ? [_c('div', {
    staticClass: "kiwi-header-name-container"
  }, [_c('div', {
    staticClass: "kiwi-header-name"
  }, [_c('div', {
    staticClass: "kiwi-header-name-full"
  }, [_vm._v(_vm._s(_vm.buffer.name))]), _vm._v(" " + _vm._s(_vm.buffer.name) + " ")])]), _c('div', {
    staticClass: "kiwi-header-center"
  }), _c('div', {
    staticClass: "kiwi-header-options"
  })] : _vm._e(), _vm.chatsiDialogOpen ? _c('div', {
    staticClass: "kiwi-chatsi-dialog-backdrop",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        $event.stopPropagation();
        return _vm.chatsiCloseDialog.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-chatsi-dialog-card",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-chatsi-dialog-title"
  }, [_vm.chatsiDialogMode === 'menu' ? [_vm._v(" Menú ")] : _vm.chatsiDialogMode === 'nick' ? [_vm._v(" Cambiar nick ")] : [_vm._v(" Desconectarse ")]], 2), _vm.chatsiDialogMode === 'menu' ? _c('div', {
    staticClass: "kiwi-chatsi-dialog-content"
  }, [_c('div', {
    staticClass: "kiwi-chatsi-menu-options"
  }, [_c('button', {
    staticClass: "kiwi-chatsi-menu-option",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.chatsiOpenNickDialog
    }
  }, [_vm._v(" Cambiar nick ")]), _c('button', {
    staticClass: "kiwi-chatsi-menu-option kiwi-chatsi-menu-option-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.chatsiOpenDisconnectDialog
    }
  }, [_vm._v(" Desconectarse ")])])]) : _vm.chatsiDialogMode === 'nick' ? _c('div', {
    staticClass: "kiwi-chatsi-dialog-content"
  }, [_c('label', {
    staticClass: "kiwi-chatsi-dialog-label",
    attrs: {
      "for": "chatsi-nick-dialog-input"
    }
  }, [_vm._v(" Nuevo nick ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.chatsiNickDraft,
      expression: "chatsiNickDraft"
    }],
    ref: "chatsiNickInput",
    staticClass: "kiwi-chatsi-dialog-input",
    attrs: {
      "id": "chatsi-nick-dialog-input",
      "type": "text",
      "autocomplete": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.chatsiNickDraft
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.chatsiConfirmNick.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.chatsiNickDraft = $event.target.value;
      }
    }
  }), _vm.chatsiDialogError ? _c('div', {
    staticClass: "kiwi-chatsi-dialog-error"
  }, [_vm._v(" " + _vm._s(_vm.chatsiDialogError) + " ")]) : _vm._e()]) : _c('div', {
    staticClass: "kiwi-chatsi-dialog-content"
  }, [_c('p', {
    staticClass: "kiwi-chatsi-dialog-message"
  }, [_vm._v(" ¿Realmente quieres desconectarte del chat? ")])]), _c('div', {
    staticClass: "kiwi-chatsi-dialog-actions"
  }, [_c('button', {
    staticClass: "kiwi-chatsi-dialog-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.chatsiCloseDialog
    }
  }, [_vm._v(" Cancelar ")]), _vm.chatsiDialogMode === 'nick' ? _c('button', {
    staticClass: "kiwi-chatsi-dialog-button kiwi-chatsi-dialog-button-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.chatsiConfirmNick
    }
  }, [_vm._v(" Cambiar ")]) : _vm.chatsiDialogMode === 'disconnect' ? _c('button', {
    staticClass: "kiwi-chatsi-dialog-button kiwi-chatsi-dialog-button-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.chatsiConfirmDisconnect
    }
  }, [_vm._v(" Desconectarse ")]) : _vm._e()])])]) : _vm._e()], 2);
};
var staticRenderFns = exports.staticRenderFns = [];